import styled from 'styled-components'

import { helpers } from 'styles'

export const Header = styled.div`
	display: flex;
	column-gap: ${helpers.spacing.medium};
	margin-bottom: ${helpers.spacing.large};
`
